const PRODUCTS = [
  // --- Newborn ---
  {
    id: 1,
    title: "Newborn",

    cat: "Newborn",
    img: [
      "/images/product/NB.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã dán Newborn Rumi" },
      { label: "Kích cỡ (size)", value: "Newborn (sơ sinh)" },
      { label: "Số miếng", value: "58" },
      { label: "Cân nặng", value: "<5kg" },
    ],
    keepInStore:
      "Bảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ",
  },
  // --- Dan ---
  {
    id: 2,
    title: "Tã Dán - size S",

    cat: "Tã Dán",
    img: [
      "/images/product/danS.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã dán Rumi Size S" },
      { label: "Kích cỡ (size)", value: "S" },
      { label: "Số miếng", value: "50" },
      { label: "Cân nặng", value: "4-8kg" },
    ],
    keepInStore:
      "Bảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ.",
  },
  {
    id: 3,
    title: "Tã Dán - size M",

    cat: "Tã Dán",
    img: [
      "/images/product/danM.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã dán Rumi Size M" },
      { label: "Kích cỡ (size)", value: "M" },
      { label: "Số miếng", value: "48" },
      { label: "Cân nặng", value: "6-11kg" },
    ],
    keepInStore:
      "Bảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ.",
  },
  // --- Quan ---
  {
    id: 4,
    title: "Tã Quần - size M",

    cat: "Tã Quần",
    img: [
      "/images/product/quanM.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã quần Rumi Size M" },
      { label: "Kích cỡ (size)", value: "M" },
      { label: "Số miếng", value: "46" },
      { label: "Cân nặng", value: "6-11kg" },
    ],
    keepInStore:
      "Bảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ.",
  },

  {
    id: 5,
    title: "Tã Quần - size L",

    cat: "Tã Quần",
    img: [
      "/images/product/quanL.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã quần Rumi Size L" },
      { label: "Kích cỡ (size)", value: "L" },
      { label: "Số miếng", value: "44" },
      { label: "Cân nặng", value: "9-14kg" },
    ],
    keepInStore:
      "Bảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ.",
  },
  {
    id: 6,
    title: "Tã Quần - size XL",

    cat: "Tã Quần",
    img: [
      "/images/product/quanXL.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã quần Rumi Size XL" },
      { label: "Kích cỡ (size)", value: "XL" },
      { label: "Số miếng", value: "42" },
      { label: "Cân nặng", value: "12-17kg" },
    ],
    keepInStore:
      "Bảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ.",
  },
  {
    id: 7,
    title: "Tã Quần - size 2XL",

    cat: "Tã Quần",
    img: [
      "/images/product/quan2XL.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã quần Rumi Size 2XL" },
      { label: "Kích cỡ (size)", value: "2XL" },
      { label: "Số miếng", value: "40" },
      { label: "Cân nặng", value: ">=15kg" },
    ],
    keepInStore:
      "Bảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ.",
  },
  {
    id: 8,
    title: "Tã Quần - size 3XL",

    cat: "Tã Quần",
    img: [
      "/images/product/quan3XL.png",
      "/images/product/chung/van3D.jpg",
      "/images/product/chung/sieumong.jpg",
      "/images/product/chung/daichun.jpg",
      "/images/product/chung/vaidetnhiet.jpg",
      "/images/product/chung/vach5cm.jpg",
    ],
    composite: "Vải dệt nhiệt, hạt SAP, bông cao cấp",
    description: [
      { label: "Sản phẩm", value: "Tã quần Rumi Size 3XL" },
      { label: "Kích cỡ (size)", value: "3XL" },
      { label: "Số miếng", value: "38" },
      { label: "Cân nặng", value: ">=18kg" },
    ],
    keepInStore:
      "BBảo quản nơi khô ráo, tránh bụi, tránh ánh nắng trực tiếp và để xa tầm tay của trẻ.",
  },
];
export default PRODUCTS;
